
document.addEventListener("DOMContentLoaded", function () {
    const App = window.WatchlistApp;
    if (!App || !App.Utils || !App.State || !App.Manager || !App.Table) {
        console.error("WatchlistApp modules not loaded correctly.");
        return;
    }

    const { Utils, State, Manager, Table } = App;

    function getCurrentWatchlistStockCount() {
        return State.getCurrentWatchlistStockCount();
    }

    const viewBtns = document.querySelectorAll('.view-toggle-buttons .view-btn');

    const watchlistSettingsPopup = document.getElementById('watchlist-settings-pop-up');
    const closeWatchlistSettingsBtn = document.getElementById('close-watchlist-settings-popup');

    const watchlistSettingsBtn = document.querySelector('.watchlist-settings-btn');
    if (watchlistSettingsBtn) {
        watchlistSettingsBtn.style.display = 'none';
        
        if (watchlistSettingsPopup) {
            watchlistSettingsBtn.addEventListener('click', function () {
                watchlistSettingsPopup.classList.add('show');
            });
        }
    }

    document.addEventListener('click', function(e) {
        if (e.target.matches('.add-unit-btn.main-add-unit-btn') || (e.target.matches('.add-unit-btn') && e.target.closest('.watchlist-table-actions'))) {
             if (App.Popup && App.Popup.showAddUnitPopup) {
                 if (!State.currentWatchlistId) {
                     return;
                 }

                 const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
                 const currentStockCount = getCurrentWatchlistStockCount();

                 if (!isPremium && currentStockCount >= 50) {
                     if (App.Popup && App.Popup.showPremiumLimitPopup) {
                         App.Popup.showPremiumLimitPopup(
                             "Unlimited stocks in watchlist are coming soon!",
                             "Adding more than 50 assets is a Pro feature currently in development."
                         );
                     }
                     return;
                 }

                App.Popup.showAddUnitPopup();
            } else {
                console.error("App.Popup.showAddUnitPopup is not defined");
            }
        }
    });

    const chartNavArrows = document.querySelector('.chart-nav-arrows');
    const leftArrow = chartNavArrows?.querySelector('.nav-arrow.left');
    const rightArrow = chartNavArrows?.querySelector('.nav-arrow.right');

    const watchlistDropdownBtn = document.getElementById('watchlist-selector-btn');
    const watchlistDropdown = document.getElementById('watchlist-selector');
    const watchlistDropdownMenu = document.getElementById('watchlist-selector-menu');

    if (watchlistDropdownBtn && watchlistDropdown) {
        watchlistDropdownBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            const State = window.WatchlistApp.State;
            if (!State.allWatchlists || State.allWatchlists.length === 0) {
                return;
            }
            watchlistDropdown.classList.toggle('active');
        });

        document.addEventListener('click', function (e) {
            if (watchlistDropdown && !watchlistDropdown.contains(e.target)) {
                watchlistDropdown.classList.remove('active');
            }
        });
    }

    const watchlistActions = document.querySelector('.watchlist-actions');
    if (watchlistActions && watchlistDropdown) {
        const addWatchlistBtn = document.createElement('button');
        addWatchlistBtn.className = 'add-watchlist-btn';
        addWatchlistBtn.title = 'Create New Watchlist';
        addWatchlistBtn.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;

        if (watchlistDropdown.nextSibling) {
            watchlistActions.insertBefore(addWatchlistBtn, watchlistDropdown.nextSibling);
        } else {
            watchlistActions.appendChild(addWatchlistBtn);
        }

        addWatchlistBtn.addEventListener('click', function () {
            const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
            const currentWatchlistCount = (State.allWatchlists || []).length;

            if (!isPremium && currentWatchlistCount >= 1) {
                if (App.Popup && App.Popup.showPremiumLimitPopup) {
                    App.Popup.showPremiumLimitPopup();
                }
                return;
            }

            const uname = Utils.getCurrentUsername();
            const defaultName = uname ? `${uname}'s watchlist` : "Watchlist";
            if (App.Popup && App.Popup.showInputPopup) {
                App.Popup.showInputPopup('Create Watchlist', defaultName, 'Watchlist Name', 'Create', async (newName) => {
                    if (newName) {
                        await Manager.createWatchlist(newName);
                    }
                }, { restrictUnicode: true });
            } else {
                const newName = prompt('Enter name for the new watchlist:', defaultName);
                if (newName) {
                    Manager.createWatchlist(newName);
                }
            }
        });
    }

    viewBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            viewBtns.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            const view = this.getAttribute('data-view');
            State.currentView = view;

            const chartWrapper = document.querySelector('.chart-wrapper');
            const bottomControls = document.querySelector('.bottom-controls');
            let tableContainer = document.querySelector('.watchlist-table-container');
            const chartPanel = document.getElementById('desktop-chart-panel');

            const bottomPlayerArea = document.querySelector('.bottom-player-area');
            const mainControls = document.querySelector('.main-controls');

            if (view === 'table') {
                if (chartWrapper) chartWrapper.style.display = 'none';
                if (bottomControls) bottomControls.style.display = 'none';
                if (mainControls) mainControls.style.display = 'none';
                if (chartPanel) {
                    chartPanel.style.display = 'none';
                    chartPanel.classList.remove('is-open');
                }
                const watchlistSettingsBtn = document.querySelector('.watchlist-settings-btn');
                if (watchlistSettingsBtn) watchlistSettingsBtn.style.display = '';


                if (!tableContainer) {
                    tableContainer = document.createElement('div');
                    tableContainer.className = 'watchlist-table-container';
                    const watchlistControls = document.querySelector('.watchlist-controls-container');
                    if (watchlistControls && watchlistControls.parentNode) {
                        watchlistControls.parentNode.insertBefore(tableContainer, watchlistControls.nextSibling);
                    }
                }

                const watchlistControlsContainer = document.querySelector('.watchlist-controls-container');
                if (watchlistControlsContainer) watchlistControlsContainer.classList.add('table-view');
                document.body.classList.add('table-view');

                tableContainer.classList.add('active');
                tableContainer.style.display = 'block';
                Table.renderWatchlistTable(tableContainer);

                if(window.gtag) gtag('event', `Desktop_TopNav_WatchlistTable`);
            } else {
                if (chartWrapper) chartWrapper.style.display = 'block';
                if (bottomControls) bottomControls.style.display = 'block';
                if (bottomPlayerArea) bottomPlayerArea.style.display = '';
                if (mainControls) mainControls.style.display = '';
                if (chartPanel) chartPanel.style.display = '';
                if (tableContainer) {
                    tableContainer.classList.remove('active');
                    tableContainer.style.display = 'none';
                }
                const watchlistSettingsBtn = document.querySelector('.watchlist-settings-btn');
                if (watchlistSettingsBtn) watchlistSettingsBtn.style.display = 'none';


                const watchlistControlsContainer = document.querySelector('.watchlist-controls-container');
                if (watchlistControlsContainer) watchlistControlsContainer.classList.remove('table-view');
                document.body.classList.remove('table-view');

                const centerContent = document.getElementById('large-center-panel-content');
                if (centerContent) {
                    centerContent.replaceChildren();
                    centerContent.setAttribute('position', '0 0 0');
                }

                if (typeof addWatchlistReportsCubeToCenterPanel === 'function') {
                    addWatchlistReportsCubeToCenterPanel();

                    const currentListId = State.currentWatchlistId;
                    if (currentListId && State.allWatchlists) {
                        const currentWatchlist = State.allWatchlists.find(w => w.id === currentListId);
                        if (currentWatchlist) {
                            const mainChartTitle = document.querySelector('.title-and-date h2');
                            if (mainChartTitle) {
                                 mainChartTitle.textContent = Utils.truncateName(currentWatchlist.name, 20);
                            }
                        }
                    }

                    const stockCube = document.getElementById('stock-3d-cube');
                    if (stockCube && State.currentWatchlistId) {
                        let currentInterval = '1d';
                        const activeIntervalBtn = document.querySelector('#main-block .time-range-wrapper .item.active');
                        if (activeIntervalBtn) currentInterval = activeIntervalBtn.getAttribute('data-range');

                        const attrs = {
                            dataSource: 'watchlist-reports',
                            interval: currentInterval,
                            watchlistId: State.currentWatchlistId
                        };

                        if (State.lastReportData) {
                            attrs.injectedData = JSON.stringify(State.lastReportData);
                        }

                        stockCube.setAttribute('stock-cube-visualizer', attrs);
                    }
                }

                if(window.gtag) gtag('event', `Desktop_TopNav_WatchlistChart`);
            }
        });
    });

    if (closeWatchlistSettingsBtn && watchlistSettingsPopup) {
        closeWatchlistSettingsBtn.addEventListener('click', function () {
            watchlistSettingsPopup.classList.remove('show');
        });
    }

    const sortOptionVariants = document.querySelectorAll('#watchlist-sort-options .variant');
    sortOptionVariants.forEach(variant => {
        variant.addEventListener('click', function () {
            sortOptionVariants.forEach(v => v.classList.remove('selected'));
            this.classList.add('selected');
            State.currentSortOption = this.getAttribute('data-value');

            const tableContainer = document.querySelector('.watchlist-table-container');
            if (tableContainer && tableContainer.classList.contains('active')) {
                Table.renderWatchlistTable(tableContainer);
            }
        });
    });

    const sortOrderVariants = document.querySelectorAll('#watchlist-sort-order .variant');
    sortOrderVariants.forEach(variant => {
        variant.addEventListener('click', function () {
            sortOrderVariants.forEach(v => v.classList.remove('selected'));
            this.classList.add('selected');
            State.currentSortOrder = this.getAttribute('data-value');

            const tableContainer = document.querySelector('.watchlist-table-container');
            if (tableContainer && tableContainer.classList.contains('active')) {
                Table.renderWatchlistTable(tableContainer);
            }
        });
    });

    document.body.addEventListener('watchlist-data-loaded', function (e) {
        State.currentWatchlistData = e.detail.stockInfo;

        const tableContainer = document.querySelector('.watchlist-table-container');
        if (tableContainer && tableContainer.classList.contains('active')) {
            Table.renderWatchlistTable(tableContainer);
        }
    });

    const scene = document.querySelector('a-scene');
    if (scene) {
        scene.addEventListener('data-interval', function (e) {
            if (document.body.classList.contains('watchlist-mode') && document.body.dataset.isSearchMode !== 'true' && !window._searchStockSelected) {

                if (State.currentUserId && State.currentWatchlistId) {
                    const interval = e.detail ? e.detail.interval : null;
                    Manager.loadWatchlistData(State.currentUserId, State.currentWatchlistId, [], interval);
                }
            }
        });
    }
});
